import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import en from 'src/constants/en'
import { AIChatCreateConversationPayload } from 'src/interfaces/aiChat'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiChatApi } from 'src/services/aiChatApi'

import { UseCreateAiChatConversationMutationParams } from './interfaces/useCreateAiChatConversationMutation.interface'

export const useCreateAiChatConversationMutation = ({
  onError,
  onSuccess,
}: UseCreateAiChatConversationMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload?: AIChatCreateConversationPayload) =>
      AiChatApi.createConversation(payload),
    onError: () => {
      toast.error(en.AI_CHAT_CREATE_CONVERSATION_ERROR)
      onError?.()
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_AI_CHAT_CONVERSATIONS],
      })
      onSuccess?.(data)
    },
  })
}
